// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mh-2";
export var interactiveWrapper = "_mh-0";
export var shippingHoverPreview = "_mh-4";
export var summaryBadgeTrigger = "_mh-1";
export var widgetHoverPreviewList = "_mh-3";
export var widgetPreviewScale = "_mh-5";